<template>
  <TimeCounter
    :class="[displayColorClass, typographyClass]"
    :timer-mode="timerMode"
    :show-icon="showIcon"
    :prefix="prefix"
    :suffix="suffix"
    :start-at="startAt"
    :end-at="nextEscalationAt"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { UrgencyWithCountdown } from '@/types/UrgencyWithCountdown'
import { type TimerMode } from '@/composables/useTimer'
import TimeCounter from '@/components/common/TimeCounter.vue'

const {
  urgency,
  nextEscalationAt,
  showIcon = true,
  dark = false,
  regular = false,
  startAt,
  timerMode
} = defineProps<{
  prefix?: string
  suffix?: string
  urgency: UrgencyWithCountdown
  nextEscalationAt?: string
  startAt?: string | null
  showIcon?: boolean
  dark?: boolean
  regular?: boolean
  timerMode: TimerMode
}>()

const colorClassByUrgencyType: Record<UrgencyWithCountdown, string> = {
  emergency: dark ? 'text-error-700' : 'text-error',
  urgent: dark ? 'text-warning-700' : 'text-warning',
  routine: 'text-primary-700'
}

const displayColorClass = computed<string>(() => colorClassByUrgencyType[urgency])

const typographyClass = computed<string>(() => {
  return regular ? '' : 'countdown-typography'
})
</script>

<style scoped>
.countdown-typography {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: 0.15px;
}
</style>
